import TicketSummary from './TicketSummary';

export default TicketSummary;
